<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Locations</h1>

      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>

      <div v-else-if="hasLocations" class="columns is-multiline is-centered">
        <div v-for="location in locations" :key="location.id" class="column is-3">
          <address>
            <strong>{{ location.name }}</strong><br>
            {{ location.address }}<br>
            {{ location.city }}, {{ location.state }} {{ location.zip_code }}<br>
          </address>
          <br>
          <p>{{ location.description }}</p>
        </div>
      </div>
      <div v-else>
        <p>
          There are no locations yet. Check back later.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import LocationsAPI from '@/services/api/Locations';

export default {
  name: 'LocationsPage',
  data() {
    return {
      loading: true,
      locations: [],
      hasLocations: false,
    };
  },
  mounted() {
    LocationsAPI.getAllLocations()
      .then(locations => {
        this.locations = locations;
        this.hasLocations = _.isEmpty(locations) ? false : true;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
</style>
